import React from "react";
import { Search } from "lucide-react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";
import { Input } from "./ui/input";

export default function FAQAccordion({ faqs, testIdPrefix = "faq" }) {
  const [q, setQ] = React.useState("");
  const filtered = faqs.filter(([qn, an]) =>
    (qn + " " + an).toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div>
      <div className="relative mb-6 max-w-xl">
        <Search className="h-4 w-4 absolute left-3 top-3.5 text-muted-foreground" />
        <Input
          data-testid={`${testIdPrefix}-search`}
          placeholder="Search FAQs..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="pl-9"
        />
      </div>
      <Accordion type="single" collapsible className="w-full">
        {filtered.map(([qn, an], i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`${testIdPrefix}-item-${i}`}>
            <AccordionTrigger className="text-left font-medium">{qn}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">{an}</AccordionContent>
          </AccordionItem>
        ))}
        {filtered.length === 0 && (
          <p className="text-sm text-muted-foreground py-6">No FAQs match your search.</p>
        )}
      </Accordion>
    </div>
  );
}
